import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import React, { useCallback, useMemo } from 'react';

import {
  directPrintShipmentGridLabels,
  downloadShipmentGridLabels,
  printShipmentGridLabels,
} from '../../../../store/shipments/grid/shipments.grid.actions';
import { printLabel } from '../../../../store/printing/print.actions';
import { usePrintSettings } from '../../core/hooks';
import { buildDefaultPrintSetting } from '../../../../containers/print-document-button-containers/core/buildDefaultPrintSetting';
import { DocumentType } from '../../../../enums/document-type';
import PrintDocumentMenuItem from '../../../../components/print-document-menu-item';

export const Label = ({ selectedData }) => {
  const dispatch = useDispatch();
  const fulfillmentPlanIds = useMemo(() => selectedData.map((f) => f.fulfillmentPlanId), [selectedData]);
  const fulfillmentIds = useMemo(
    () => selectedData.filter((f) => !!f.fulfillmentId && !f.isLabelVoided).map((f) => f.fulfillmentId),
    [selectedData],
  );
  const isDisabled = selectedData.filter((f) => !!f.fulfillmentId && !f.isLabelVoided && f.isLabelCreated).length === 0;
  const printSettings = usePrintSettings(DocumentType.Label.printSettingKey);
  const onClick = useCallback(() => {
    if (fulfillmentIds.length === 1) {
      const hasPrintedLabel = !!selectedData.find((f) => f.isLabelPrinted);
      dispatch(printLabel(fulfillmentPlanIds, fulfillmentIds, hasPrintedLabel, false, false));
    } else {
      dispatch(printShipmentGridLabels(false));
    }
  }, [dispatch, fulfillmentIds, fulfillmentPlanIds, selectedData]);
  const onDownload = useCallback(() => {
    dispatch(downloadShipmentGridLabels());
  }, [dispatch]);
  const onPrint = useCallback(() => {
    dispatch(directPrintShipmentGridLabels());
  }, [dispatch]);
  const defaultPrintSetting = useMemo(
    () => buildDefaultPrintSetting(printSettings, onPrint, onDownload),
    [onDownload, onPrint, printSettings],
  );

  return (
    <PrintDocumentMenuItem
      defaultPrintSetting={defaultPrintSetting}
      disabled={isDisabled}
      name={DocumentType.Label.documentNameTranslation}
      onClick={onClick}
    />
  );
};

Label.propTypes = {
  selectedData: PropTypes.arrayOf(
    PropTypes.shape({
      fulfillmentId: PropTypes.string.isRequired,
      fulfillmentPlanId: PropTypes.string.isRequired,
      isLabelCreated: PropTypes.bool,
      isLabelVoided: PropTypes.bool,
    }),
  ).isRequired,
};
